import React, { useContext } from "react";

import { FlujoValidarPagoPLux } from ".";

import TransaccionalContext from "../context/TransaccionalContext";

import useMerchantStorage from "../hooks/useMerchantPago";
import CardInformacionLinkPago from "../components/CardInformacionLinkPago";
import MainContentInformacion from "../components/MainContentInformacion";

const DetallePayment = ({
  cabenceraTransaccional,
  datosBusqueda,
  alturaResolucion,
}) => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [idMerchantStorage, setIdMerchantStorage] = useMerchantStorage(
    "idMerchantStorage",
    null
  );

  // TODO => si hay un registro en nueva tabla
  // guardar el merchant
  // guardar datos de la tabla si exisaten

  return (
    <>
      <MainContentInformacion alturaResolucion={alturaResolucion}>
        {!informacionTransaccional.stateVerificar ? (
          <>
            <CardInformacionLinkPago />
          </>
        ) : (
          <main className="detallePayment_container">
            <FlujoValidarPagoPLux alturaResolucion={alturaResolucion} />
          </main>
        )}
      </MainContentInformacion>
    </>
  );
};

export default DetallePayment;
